import SharedDashboard from './SharedDashboard';

export default SharedDashboard;
